import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialType } from '../../models/materialtype/materialtype.model';
import { MaterialTypeService } from '../../services/material-type.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DialogUploadComponent } from 'src/app/core/components/dialog-upload/dialog-upload.component';
import { MaterialTypeConstant } from 'src/app/core/constants/material-type.constants';
import { CommonService } from 'src/app/core/services/common.service';
import { RoleConstant } from 'src/app/core/constants/role.constants';

@Component({
    selector: 'app-material-type',
    templateUrl: './material-type.component.html',
    styleUrls: ['./material-type.component.css'],
    standalone: false
})
export class MaterialTypeComponent implements OnInit {
  constructor(private materialTypeService: MaterialTypeService,
    private route: ActivatedRoute,
    public router: Router,
    private dialogService: DialogService,
    public commonService: CommonService
  ) { }

  public gridData: MaterialType[] = [];
  public globalGridData: MaterialType[] = [];
  public checked: true = true;
  public searchText: string = '';
  public showInactive = false;

  ngOnInit() {
    if (this.commonService.getUserRoleName() !== RoleConstant.ESAR_Admin) {
      this.router.navigate(['../../sar'], { relativeTo: this.route });
      return false;
    }
    this.getMaterialType();
  }

  getMaterialType() {
    this.materialTypeService.getMaterialType().subscribe((response: MaterialType[]) => {
      this.globalGridData = Object.assign([], response);
      this.updateGrid();
    });
  }

  updateGrid() {
    this.gridData = this.commonService.setupGobalSearch(this.globalGridData, this.showInactive, MaterialTypeConstant.searchFieldName, this.searchText, MaterialTypeConstant.code);
  }


  cancelSearch() {
    this.searchText = '';
    this.updateGrid();
  }

  activeChanged(value: boolean) {
    this.showInactive = value;
    this.updateGrid();
  }

  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }

  manage(isCreate: boolean, isActive: boolean, name: string, id: number, code: string) {
    this.router.navigate(["../manageMaterialType"], {
      state: { 'isCreate': isCreate, 'id': id, 'name': name, 'isActive': isActive, 'code': code },
      relativeTo: this.route
    },
    );
  }

  public import(): void {
    const dialog: DialogRef = this.dialogService.open({
      content: DialogUploadComponent
    });

    dialog.result.subscribe((r: any) => {
      if (r.action === "Save") {
        let arr = JSON.parse(r.value).Sheet1 as Array<any>;
        let mt: MaterialType[] = arr.map((item: any) => {
          return {
            id: 0,
            name: item['Material Type'].toString(), code: item['UOM Code'].toString(), isActive: item['Is Active'],
            createdBy: item['Created By'], modifiedBy: item['Modified By'],
            createdDateTime: undefined, modifiedDateTime: undefined
          };
        });
        this.materialTypeService.importExcelData(mt).subscribe((response: MaterialType) => {
          this.commonService.showNotificationMessage(MaterialTypeConstant.bulkInsertMessage, 'success', 'right')
          this.getMaterialType();
        });
      }
    });
  }
}

